module.exports = __webpack_public_path__ + "assets/img/limit_160.909c1842.png";